var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewportRef",staticClass:"workflow__viewport workflow__container"},[_c('WorkflowPane',{class:{
      dragging: _vm.paneDragging,
      draggable:
        _vm.panOnDrag === true ||
        (Array.isArray(_vm.panOnDrag) && _vm.panOnDrag.includes(0))
    }},[_c('WorkflowTransform',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }